export const NEXT = 'NEXT'
export const PREV = 'PREV'
export const CHECK_PASSWORD_MATCH = 'CHECK_PASSWORD_MATCH'
export const VALIDATE_PASSWORD = 'VALIDATE_PASSWORD'
export const SET_FIELD = 'SET_FIELD'
export const SET_ERROR = 'SET_ERROR'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_STEPS = 'SET_STEPS'
export const SET_RETRIEVAL_METHOD = 'SET_RETRIEVAL_METHOD'
